import dayjs from 'dayjs';
import type { FlowByPhaseDataOverTime } from '../../../../api/work-periods-client/work-periods-client.type';
import { PHASES } from './flow-by-phase-tab.constants';

/**
 * Creates an object with all phases set to visible (true).
 *
 * @returns {Record<string, boolean>} An object with phase names as keys and boolean values (all true)
 */
const getInitialVisiblePhases = (): Record<string, boolean> => {
  return Object.fromEntries(PHASES.map((phase) => [phase, true]));
};

/**
 * Finds the most recent date in the Flow by Phase data that has actual data.
 * A date is considered to have data if any phase has a non-null value greater than 0.
 *
 * @param {FlowByPhaseDataOverTime} data - The Flow by Phase data over time
 * @returns {string | null} The latest date with data in ISO format, or null if no dates with data are found
 */
const getLatestDateWithData = (data: FlowByPhaseDataOverTime): string | null => {
  try {
    const dates = Object.entries(data)
      .filter(([_, values]) => {
        if (!values || typeof values !== 'object') return false;

        return Object.entries(values).some(([_, value]) => {
          return value !== null && typeof value === 'number' && value > 0;
        });
      })
      .map(([date]) => date)
      .sort((a, b) => dayjs(b).diff(dayjs(a)));

    return dates.length > 0 ? dates[0] : null;
  } catch (error) {
    console.error('Error finding latest date with data:', error);
    return null;
  }
};

export { getInitialVisiblePhases, getLatestDateWithData };
